import { useMemo, useRef } from "react";

import { MedfarDictionariesValidationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/MedfarDictionariesValidationRule";
import { MedfarDictionariesValidationRuleTypeEnum } from "@/Common/Models/MedfarDictionaries/Enums/MedfarDictionariesValidationRuleTypeEnum";
import { MedfarDictionariesValidationHelper } from "@/ContactDirectory/Helpers/MedfarDictionariesValidationHelper";

export const useMedfarDictionariesValidationRule = (ruleType: MedfarDictionariesValidationRuleTypeEnum, geoCountryId: string, geoStateId: string = null): MedfarDictionariesValidationRule => {
    const helper = useRef(new MedfarDictionariesValidationHelper(cacheStore.MedfarDictionariesValidationRules));

    return useMemo(() => helper.current.getValidationRuleForCountryAndRegion(ruleType, geoCountryId, geoStateId), [ruleType, geoCountryId, geoStateId]);
};
